<template>
  <div class="container-fluid">
    <b-card>
      <form @submit.prevent="saveConfigurations">
        <b-tabs>
          <b-tab title="Mensagens" active>
            <tab-message></tab-message>
          </b-tab>
          <b-tab title="Dashboard">
            <tab-dashboard></tab-dashboard>
          </b-tab>
          <b-tab title="Relatórios">
            <tab-reports></tab-reports>
          </b-tab>
          <b-tab title="Formalizações x Pós venda">
            <tab-formalization-after-sale></tab-formalization-after-sale>
          </b-tab>
        </b-tabs>
        <div class="row mt-1">
          <div class="col-12">
            <b-button type="submit" variant="success">Salvar</b-button>
          </div>
        </div>
      </form>
    </b-card>
  </div>
</template>
<script>
import TabMessage from "./Tabs/Messages/Index";
import TabDashboard from "./Tabs/Dashboard/Index";
import TabReports from "./Tabs/Reports/Index";
import TabFormalizationAfterSale from "./Tabs/FormalizationAfterSale/Index";
export default {
  components: {
    TabMessage,
    TabDashboard,
    TabReports,
    TabFormalizationAfterSale,
  },
  computed: {
  },
  created() {
    this.getConfigurations();
  },
  data() {
    return {
    };
  },
  methods: {
    getConfigurations() {
      const self = this;
      this.$root.$emit("onLoading");
      const response = this.$store.dispatch("configurations/all");

      response.then(r => {
        self.$root.$emit("onLoading");
      });

      response.catch(err => {
        self.$root.$emit("onLoading");
      });
    },
    saveConfigurations() {
      var self = this;
      self.$root.$emit("onLoading");
      const response = self.$store.dispatch("configurations/save");

      response.then(function() {
        self.$root.$emit("onLoading");
        self.$notify.success("Configuração salva com sucesso!");
      });

      response.catch(function(err) {
        self.$root.$emit("onLoading");
      });
    },
  },
};
</script>